// 播放
export const PLAY = "PLAY";
// 暂停
export const PAUSE = "PAUSE";
// 停止
export const STOP = "STOP";
// 其他电台
export const OTHER_VIDEO = "OTHER_VIDEO"
// 虚拟电台
export const VIRTUAL_VIDEO = "VIRTUAL_VIDEO"
// 音频
export const AUDIO = "AUDIO"

export default {
    // 音频常量
    PLAY,
    PAUSE,
    STOP,

    OTHER_VIDEO,
    VIRTUAL_VIDEO,
    AUDIO
}